var _rect, _rect2, _rect3, _rect4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#135E70"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 16,
    y: 9,
    width: 16,
    height: 16,
    fill: "#61DAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.636,
    y: 21.9498,
    width: 16,
    height: 2,
    transform: "rotate(-45 17.636 21.9498)",
    fill: "#61DAFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0503,
    y: 10.636,
    width: 16,
    height: 2,
    transform: "rotate(45 19.0503 10.636)",
    fill: "#61DAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2764 38.1641C14.3408 38.1641 15.9199 36.9404 16.2959 35.0537L16.3096 34.9854H15.0654L15.0449 35.0469C14.6143 36.3457 13.6572 37.0293 12.2764 37.0293C10.3145 37.0293 9.03613 35.4639 9.03613 33.0645V33.0576C9.03613 30.6582 10.3076 29.1064 12.2764 29.1064C13.6641 29.1064 14.6348 29.8037 15.0176 31L15.0654 31.1504H16.3096L16.2959 31.082C15.9199 29.2158 14.3271 27.9717 12.2764 27.9717C9.52832 27.9717 7.77148 29.9541 7.77148 33.0576V33.0645C7.77148 36.168 9.53516 38.1641 12.2764 38.1641ZM17.6426 38H18.832V28.1357H17.6426V38ZM23.3848 38.1367C25.3467 38.1367 26.6729 36.7148 26.6729 34.4453V34.4316C26.6729 32.1621 25.3398 30.7539 23.3779 30.7539C21.416 30.7539 20.0898 32.1689 20.0898 34.4316V34.4453C20.0898 36.708 21.4092 38.1367 23.3848 38.1367ZM23.3916 37.084C22.1338 37.084 21.3066 36.1201 21.3066 34.4453V34.4316C21.3066 32.7705 22.1406 31.8066 23.3779 31.8066C24.6357 31.8066 25.4561 32.7637 25.4561 34.4316V34.4453C25.4561 36.1133 24.6426 37.084 23.3916 37.084ZM30.3984 38.1367C31.9844 38.1367 33.1602 37.2617 33.1602 36.0176V36.0107C33.1602 34.999 32.6406 34.4316 31.2051 34.083L30.0771 33.8096C29.291 33.6182 28.9697 33.2832 28.9697 32.7979V32.791C28.9697 32.1621 29.5029 31.7451 30.3643 31.7451C31.2461 31.7451 31.7725 32.2031 31.8682 32.8936L31.875 32.9414H33.0098L33.0029 32.8525C32.9141 31.6631 31.9229 30.7539 30.3643 30.7539C28.8262 30.7539 27.7529 31.6221 27.7529 32.8457V32.8525C27.7529 33.8779 28.4023 34.5 29.7422 34.8213L30.8701 35.0947C31.6768 35.293 31.9434 35.5801 31.9434 36.0928V36.0996C31.9434 36.7422 31.3691 37.1455 30.4053 37.1455C29.4346 37.1455 28.9082 36.7285 28.7646 36.0176L28.751 35.9492H27.5615L27.5684 36.0107C27.7119 37.2822 28.7236 38.1367 30.3984 38.1367ZM37.3232 38.1367C38.875 38.1367 40.0371 37.207 40.2695 36.0312L40.2832 35.9629H39.1143L39.0938 36.0244C38.8887 36.6328 38.2529 37.084 37.3506 37.084C36.0859 37.084 35.2793 36.2295 35.252 34.7666H40.3721V34.3291C40.3721 32.1963 39.1895 30.7539 37.248 30.7539C35.3066 30.7539 34.0488 32.2646 34.0488 34.4658V34.4727C34.0488 36.708 35.2793 38.1367 37.3232 38.1367ZM37.2412 31.8066C38.2803 31.8066 39.0459 32.4561 39.1621 33.8369H35.2725C35.4023 32.5107 36.209 31.8066 37.2412 31.8066Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a1b81e8f6764d8ce4bea60544dec3478.svg";
export { ForwardRef as ReactComponent };